import React from "react";
import databaseI from '../../images/home/database.png';

function DatabaseSolutions() {
  return (
    <>

      <Hero />

      <section className="service-content-section">
        <div className="container">
          <div className="row align-items-center g-5">
            <div className="col-lg-6">
              <img
                src={databaseI}
                alt="Database Solutions"
                className="service-main-image"
              />
            </div>

            <div className="col-lg-6">
              <div className="service-content">

                <h2>Organize And Manage Your Business Data</h2>

                <p>
                  A reliable database is an important part of any business
                  application. We design databases around application
                  requirements, business processes, and expected data growth.
                </p>

                <p>
                  Our experience includes SQL-based databases, MongoDB, and
                  database integration for modern applications.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="service-features-section">
        <div className="container">
          <div className="section-heading text-center">

            <h2>Database Services</h2>
          </div>

          <div className="row g-4">
            {[
              ["SQL Databases", "Structured database solutions for business applications and transactional systems."],
              ["MongoDB", "Flexible document-based data storage for modern applications."],
              ["Database Design", "Well-structured database architecture designed around your application."]
            ].map(([title, text]) => (
              <div className="col-lg-4 col-md-6" key={title}>
                <div className="service-feature-card">
                  <h3>{title}</h3>
                  <p>{text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CTA />
    </>
  );
}

function Hero() {
  return (
    <section
      className="service-page-hero"
      style={{ backgroundColor: '#002952' }}
    >
      <div className="container">
        <div className="service-hero-content">

          <h1>Database Solutions</h1>
          <p style={{ color: '#FF7D37' }}>
            Reliable database design and solutions for your applications and
            business data.
          </p>
        </div>
      </div>
    </section>
  );
}

function CTA() {
  return (
    <section className="service-cta-section">
      <div className="container">
        <div className="service-cta-box">
          <div>
            <span>DATABASE SOLUTIONS</span>
            <h2>Need Help With Your Data?</h2>
            <p>Let's discuss your database requirements.</p>
          </div>
          <a href="/contactus" className="service-cta-button">
            Contact Us
          </a>
        </div>
      </div>
    </section>
  );
}

export default DatabaseSolutions;